import {
  Drawer,
  Checkbox,
  Divider,
  Space,
  Button,
  notification,
  Skeleton,
  Empty,
  Tooltip,
} from "antd";
import confirm from "antd/lib/modal/confirm";
import { Observer, observer } from "mobx-react-lite";
import React, { createContext, useContext, useEffect, useRef } from "react";
import { Cpu, Eye, Type, X, Settings, Play } from "react-feather";
import { getComponent } from "@syncfusion/ej2-base";
import { QueryBuilderComponent } from "@syncfusion/ej2-react-querybuilder";
import { MultiSelect } from "@syncfusion/ej2-react-dropdowns";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";
import { ProgressIndicator } from "@fluentui/react";
import TextArea from "antd/lib/input/TextArea";
import {
  ConsoleSqlOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SaveFilled,
} from "@ant-design/icons";
import { toJS } from "mobx";
import { columns } from "./ColumnHelpers";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CommandBar } from "@fluentui/react";
import { Link } from "@fluentui/react";
import { TextBox } from "@syncfusion/ej2-inputs";
import PDFExportPanel from "./pdfExport/PDFExportPanel";

const _ = require("underscore");
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const MonthlyQuery = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  useEffect(() => {
    try {
      async function loadHierarchyData() {
        await monthlyPerformanceStore.monthlySettingsStore.loadHierarchy();
      }
      loadHierarchyData();
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description:
          "something went wrong while loading hierarchy data,reload the page or change operator criteria",
      });
    }
  }, [monthlyPerformanceStore.monthlySettingsStore]);
  const qryBldrObj = useRef(null);
  const queryGrid = useRef(null);
  const onChange = (args) => {
    // const data = qryBldrObj.current.getSqlFromRules();
    try {
      if (qryBldrObj.current) {
        const queryCriteria = qryBldrObj.current.getSqlFromRules(
          qryBldrObj.current.getRules()
        );
        monthlyPerformanceStore.sqlQueryCriteria =
          queryCriteria.length > 0 ? `where ${queryCriteria}` : "";
        monthlyPerformanceStore.sqlCommand = `${monthlyPerformanceStore.sqlColumns}  ${monthlyPerformanceStore.sqlQueryCriteria}`;
        monthlyPerformanceStore.gridHeader = "";
      }
    } catch (error) {}
  };

  const queryConditionsData = [
    {
      field: "Flowstation",
      label: "Flowstation",
      type: "string",
      operators: [
        { key: "Equal", value: "equal" },
        { key: "Not Equal", value: "notequal" },
        { key: "In", value: "in" },
        { key: "Not In", value: "notin" },

        { key: "Contains", value: "contains" },
        { key: "Ends With", value: "endswith" },
        { key: "Starts With", value: "startswith" },
        { key: "Not Starts With", value: "notstartswith" },
        { key: "Is Not Empty", value: "isnotempty" },
        { key: "Is Empty", value: "isempty" },
        { key: "Is Not Null", value: "isnotnull" },
        { key: "Is Null", value: "isnull" },
      ],
      template: {
        create: () => {
          qryBldrObj.current.elem = document.createElement("input");
          qryBldrObj.current.elem.setAttribute("type", "text");
          return qryBldrObj.current.elem;
        },
        destroy: (args) => {
          qryBldrObj.current.multiSelectObj = getComponent(
            document.getElementById(args.elementId),
            "multiselect"
          );
          if (qryBldrObj.current.multiSelectObj) {
            qryBldrObj.current.multiSelectObj.destroy();
          }
          qryBldrObj.current.dropDownObj = getComponent(
            document.getElementById(args.elementId),
            "dropdownlist"
          );
          if (qryBldrObj.current.dropDownObj) {
            qryBldrObj.current.dropDownObj.destroy();
          }
        },
        write: (args) => {
          let _args = args;
          const ds = _.sortBy(
            _.uniq(
              _.pluck(
                [
                  ...monthlyPerformanceStore.monthlySettingsStore.hierarchy.values(),
                ].map((x) => toJS(x)),
                "flowstation"
              )
            )
          );

          if (args.operator === "in" || args.operator === "notin") {
            try {
              qryBldrObj.current.multiSelectObj = new MultiSelect({
                change: (e) => {
                  qryBldrObj.current.notifyChange(e.value, e.element);
                },
                dataSource: ds,
                mode: "Box",
                placeholder: "Select Flowstation",
                value: args.values,
              });
              qryBldrObj.current.multiSelectObj.appendTo(
                "#" + args.elements.id
              );
            } catch (error) {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "something went wrong while loading flowstations,reload the page or change operator criteria",
              });
            }
          } else {
            qryBldrObj.current.dropDownObj = new TextBox({
              change: (e) => {
                qryBldrObj.current.notifyChange(e.value, _args.elements);
              },
            });
            qryBldrObj.current.dropDownObj.appendTo("#" + args.elements.id);
          }
        },
      },
    },
    {
      field: "Field",
      label: "Field",
      type: "string",
      operators: [
        { key: "Equal", value: "equal" },
        { key: "Not Equal", value: "notequal" },
        { key: "In", value: "in" },
        { key: "Not In", value: "notin" },

        { key: "Contains", value: "contains" },
        { key: "Ends With", value: "endswith" },
        { key: "Starts With", value: "startswith" },
        { key: "Not Starts With", value: "notstartswith" },
        { key: "Is Not Empty", value: "isnotempty" },
        { key: "Is Empty", value: "isempty" },
        { key: "Is Not Null", value: "isnotnull" },
        { key: "Is Null", value: "isnull" },
      ],
      template: {
        create: () => {
          qryBldrObj.current.elem = document.createElement("input");
          qryBldrObj.current.elem.setAttribute("type", "text");
          return qryBldrObj.current.elem;
        },
        destroy: (args) => {
          qryBldrObj.current.multiSelectObj = getComponent(
            document.getElementById(args.elementId),
            "multiselect"
          );
          if (qryBldrObj.current.multiSelectObj) {
            qryBldrObj.current.multiSelectObj.destroy();
          }
          qryBldrObj.current.dropDownObj = getComponent(
            document.getElementById(args.elementId),
            "dropdownlist"
          );
          if (qryBldrObj.current.dropDownObj) {
            qryBldrObj.current.dropDownObj.destroy();
          }
        },
        write: (args) => {
          let _args = args;
          const ds = _.uniq(
            _.pluck(
              [
                ...monthlyPerformanceStore.monthlySettingsStore.hierarchy.values(),
              ].map((x) => toJS(x)),
              "field"
            )
          );

          if (args.operator === "in" || args.operator === "notin") {
            try {
              qryBldrObj.current.multiSelectObj = new MultiSelect({
                change: (e) => {
                  qryBldrObj.current.notifyChange(e.value, e.element);
                },
                dataSource: ds,
                mode: "Box",
                placeholder: "Select Asset Field",
                value: args.values,
              });
              qryBldrObj.current.multiSelectObj.appendTo(
                "#" + args.elements.id
              );
            } catch (error) {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "something went wrong while loading asset fields,reload the page or change operator criteria",
              });
            }
          } else {
            qryBldrObj.current.dropDownObj = new TextBox({
              change: (e) => {
                qryBldrObj.current.notifyChange(e.value, _args.elements);
              },
            });
            qryBldrObj.current.dropDownObj.appendTo("#" + args.elements.id);
          }
        },
      },
    },
    {
      field: "Well",
      label: "Well",
      type: "string",
      operators: [
        { key: "Equal", value: "equal" },
        { key: "Not Equal", value: "notequal" },
        { key: "In", value: "in" },
        { key: "Not In", value: "notin" },

        { key: "Contains", value: "contains" },
        { key: "Ends With", value: "endswith" },
        { key: "Starts With", value: "startswith" },
        { key: "Not Starts With", value: "notstartswith" },
        { key: "Is Not Empty", value: "isnotempty" },
        { key: "Is Empty", value: "isempty" },
        { key: "Is Not Null", value: "isnotnull" },
        { key: "Is Null", value: "isnull" },
      ],
      template: {
        create: () => {
          qryBldrObj.current.elem = document.createElement("input");
          qryBldrObj.current.elem.setAttribute("type", "text");
          return qryBldrObj.current.elem;
        },
        destroy: (args) => {
          qryBldrObj.current.multiSelectObj = getComponent(
            document.getElementById(args.elementId),
            "multiselect"
          );
          if (qryBldrObj.current.multiSelectObj) {
            qryBldrObj.current.multiSelectObj.destroy();
          }
          qryBldrObj.current.dropDownObj = getComponent(
            document.getElementById(args.elementId),
            "dropdownlist"
          );
          if (qryBldrObj.current.dropDownObj) {
            qryBldrObj.current.dropDownObj.destroy();
          }
        },
        write: (args) => {
          let _args = args;
          const ds = _.sortBy(
            _.uniq(
              _.pluck(
                [
                  ...monthlyPerformanceStore.monthlySettingsStore.hierarchy.values(),
                ].map((x) => toJS(x)),
                "well"
              )
            )
          );

          if (args.operator === "in" || args.operator === "notin") {
            try {
              qryBldrObj.current.multiSelectObj = new MultiSelect({
                change: (e) => {
                  qryBldrObj.current.notifyChange(e.value, e.element);
                },
                dataSource: ds,
                mode: "Box",
                placeholder: "Select Asset Well",
                value: args.values,
              });
              qryBldrObj.current.multiSelectObj.appendTo(
                "#" + args.elements.id
              );
            } catch (error) {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "something went wrong while loading asset wells,reload the page or change operator criteria",
              });
            }
          } else {
            qryBldrObj.current.dropDownObj = new TextBox({
              change: (e) => {
                qryBldrObj.current.notifyChange(e.value, _args.elements);
              },
            });
            qryBldrObj.current.dropDownObj.appendTo("#" + args.elements.id);
          }
        },
      },
    },

    {
      field: "Level",
      label: "Level",
      type: "string",
      operators: [
        { key: "Equal", value: "equal" },
        { key: "Not Equal", value: "notequal" },
        { key: "In", value: "in" },
        { key: "Not In", value: "notin" },

        { key: "Contains", value: "contains" },
        { key: "Ends With", value: "endswith" },
        { key: "Starts With", value: "startswith" },
        { key: "Not Starts With", value: "notstartswith" },
        { key: "Is Not Empty", value: "isnotempty" },
        { key: "Is Empty", value: "isempty" },
        { key: "Is Not Null", value: "isnotnull" },
        { key: "Is Null", value: "isnull" },
      ],
      template: {
        create: () => {
          qryBldrObj.current.elem = document.createElement("input");
          qryBldrObj.current.elem.setAttribute("type", "text");
          return qryBldrObj.current.elem;
        },
        destroy: (args) => {
          qryBldrObj.current.multiSelectObj = getComponent(
            document.getElementById(args.elementId),
            "multiselect"
          );
          if (qryBldrObj.current.multiSelectObj) {
            qryBldrObj.current.multiSelectObj.destroy();
          }
          qryBldrObj.current.dropDownObj = getComponent(
            document.getElementById(args.elementId),
            "dropdownlist"
          );
          if (qryBldrObj.current.dropDownObj) {
            qryBldrObj.current.dropDownObj.destroy();
          }
        },
        write: (args) => {
          let _args = args;
          const ds = _.sortBy(
            _.uniq(
              _.pluck(
                [
                  ...monthlyPerformanceStore.monthlySettingsStore.hierarchy.values(),
                ].map((x) => toJS(x)),
                "level"
              )
            )
          );

          if (args.operator === "in" || args.operator === "notin") {
            try {
              qryBldrObj.current.multiSelectObj = new MultiSelect({
                change: (e) => {
                  qryBldrObj.current.notifyChange(e.value, e.element);
                },
                dataSource: ds,
                mode: "Box",
                placeholder: "Select Asset Level",
                value: args.values,
              });
              qryBldrObj.current.multiSelectObj.appendTo(
                "#" + args.elements.id
              );
            } catch (error) {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "something went wrong while loading asset levels,reload the page or change operator criteria",
              });
            }
          } else {
            qryBldrObj.current.dropDownObj = new TextBox({
              change: (e) => {
                qryBldrObj.current.notifyChange(e.value, _args.elements);
              },
            });
            qryBldrObj.current.dropDownObj.appendTo("#" + args.elements.id);
          }
        },
      },
    },
    {
      field: "UniqueId",

      label: "UniqueId",
      type: "string",
    },

    {
      field: "Production_Year",

      label: "Production Year",
      type: "number",
    },
    {
      field: "Production_Month",

      label: "Production Month",
      type: "number",
    },
    {
      field: "Production_Month_Name",

      label: "Production Month Name",
      type: "string",
      operators: [
        { key: "Equal", value: "equal" },
        { key: "Not Equal", value: "notequal" },
        { key: "In", value: "in" },
        { key: "Not In", value: "notin" },

        { key: "Contains", value: "contains" },
        { key: "Ends With", value: "endswith" },
        { key: "Starts With", value: "startswith" },
        { key: "Not Starts With", value: "notstartswith" },
        { key: "Is Not Empty", value: "isnotempty" },
        { key: "Is Empty", value: "isempty" },
        { key: "Is Not Null", value: "isnotnull" },
        { key: "Is Null", value: "isnull" },
      ],
      template: {
        create: () => {
          qryBldrObj.current.elem = document.createElement("input");
          qryBldrObj.current.elem.setAttribute("type", "text");
          return qryBldrObj.current.elem;
        },
        destroy: (args) => {
          qryBldrObj.current.multiSelectObj = getComponent(
            document.getElementById(args.elementId),
            "multiselect"
          );
          if (qryBldrObj.current.multiSelectObj) {
            qryBldrObj.current.multiSelectObj.destroy();
          }
          qryBldrObj.current.dropDownObj = getComponent(
            document.getElementById(args.elementId),
            "dropdownlist"
          );
          if (qryBldrObj.current.dropDownObj) {
            qryBldrObj.current.dropDownObj.destroy();
          }
        },
        write: (args) => {
          let _args = args;
          const ds = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          if (args.operator === "in" || args.operator === "notin") {
            try {
              qryBldrObj.current.multiSelectObj = new MultiSelect({
                change: (e) => {
                  qryBldrObj.current.notifyChange(e.value, e.element);
                },
                dataSource: ds,
                mode: "Box",
                placeholder: "Select Production Month",
                value: args.values,
              });
              qryBldrObj.current.multiSelectObj.appendTo(
                "#" + args.elements.id
              );
            } catch (error) {
              notification.error({
                message: "SPARS Feedback",
                description:
                  "something went wrong while loading production month,reload the page or change operator criteria",
              });
            }
          } else {
            qryBldrObj.current.dropDownObj = new TextBox({
              change: (e) => {
                qryBldrObj.current.notifyChange(e.value, _args.elements);
              },
            });
            qryBldrObj.current.dropDownObj.appendTo("#" + args.elements.id);
          }
        },
      },
    },
    {
      field: "Type",
      type: "string",
      label: "Type",
    },
    {
      field: "Choke",
      type: "number",
      label: "Choke",
    },
    {
      field: "Last_Date_Produced",
      type: "date",
      label: "Last Date Produced",
    },
    {
      field: "Month_Produced",
      type: "number",
      label: "Month Produced",
    },
    {
      field: "Days_Produced",
      type: "number",
      label: "Days Produced",
    },
    {
      field: "FTHP",
      type: "number",
      label: "FTHP",
    },
    {
      field: "BSW",
      type: "number",
      label: "BSW",
    },
    {
      field: "API",
      type: "number",
      label: "API",
    },
    {
      field: "Initial_GOR",
      type: "number",
      label: "Initial GOR",
    },
    {
      field: "Producing_GOR",
      type: "number",
      label: "Producing GOR",
    },
    {
      field: "Oil_Volume",
      type: "number",
      label: "Oil Volume",
    },
    {
      field: "Gas_Volume",
      type: "number",
      label: "Gas Volume",
    },
    {
      field: "Water_Volume",
      type: "number",
      label: "Water Volume",
    },
    {
      field: "Oil_Rate",
      type: "number",
      label: "Oil Rate",
    },
    {
      field: "Gas_Rate",
      type: "number",
      label: "Gas Rate",
    },

    {
      field: "Oil_Cummulative",
      type: "number",
      label: "Oil Cummulative",
    },
    {
      field: "Gas_Cummulative",
      type: "number",
      label: "Gas Cummulative",
    },
    {
      field: "Water_Cummulative",
      type: "number",
      label: "Water Cummulative",
    },

    {
      field: "Remarks",
      type: "string",
      label: "Remarks",
    },
  ];
  /* const onGridReady = (params) => {
    console.log("grid ready");
    console.log(params.columnApi);
    console.log(queryGrid.current.api);
  }; */
  return (
    <Drawer
      destroyOnClose={true}
      visible={monthlyPerformanceStore.showQueryDialog}
      onClose={() => {
        monthlyPerformanceStore.showQueryDialog = false;
      }}
      width="90%"
      title={
        <div style={{ fontSize: "15px" }}>
          <ConsoleSqlOutlined style={{ fontSize: "30px" }} className="qicon" />
          &nbsp;
          <span>{monthlyPerformanceStore.headerText}</span>
          {" Production Data Query Editor"}
        </div>
      }
      placement="right"
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm7">
            <SubPageHeaderTitle title="Query Builder Pane" />{" "}
            <Divider>
              <span>Select Query Columns</span>
            </Divider>
            <Checkbox.Group
              options={columns}
              value={monthlyPerformanceStore.queryColumns}
              onChange={(checkedValues) => {
                if (checkedValues.length) {
                  let cmd = `select ${checkedValues.toString()} from Monthly_Productions`;
                  monthlyPerformanceStore.queryColumns = checkedValues;
                  monthlyPerformanceStore.saveQueryType = 1;
                  monthlyPerformanceStore.sqlColumns = cmd;
                  monthlyPerformanceStore.gridHeader = "";
                  monthlyPerformanceStore.sqlCommand = `${monthlyPerformanceStore.sqlColumns}  ${monthlyPerformanceStore.sqlQueryCriteria}`;
                } else {
                  monthlyPerformanceStore.sqlCommand = "";
                  if (queryGrid.current) {
                    queryGrid.current.api.setColumnDefs([]);
                  }
                }
              }}
            />
            <Divider>Query Criteria</Divider>
            <QueryBuilderComponent
              width="100%"
              columns={queryConditionsData}
              allowValidation={true}
              change={onChange}
              ref={qryBldrObj}
            />
          </div>
          <div className="ms-Grid-col ms-sm5">
            <SubPageHeaderTitle title="SPARS Structured Query Language(SQL) Pane" />
            <CommandBar
              items={[
                {
                  key: "open",
                  onRenderIcon: () => <Eye size={14} className="qicon" />,

                  onRender: () => (
                    <Button
                      type="danger"
                      ghost
                      onClick={() => {
                        monthlyPerformanceStore.queryGrid = queryGrid;
                        monthlyPerformanceStore.qryBldrObj = qryBldrObj;
                        monthlyPerformanceStore.showQueryListDrawer = true;
                        console.log(
                          "guery grid",
                          monthlyPerformanceStore.queryGrid
                        );
                      }}
                    >
                      View query templates..
                    </Button>
                  ),
                },
              ]}
            ></CommandBar>
            <Observer>
              {() => (
                <TextArea
                  className="code"
                  style={{
                    borderLeft: "4px solid #FAA632",
                    minHeight: "130px",
                    backgroundColor: "#111",
                    padding: "20px",
                    color: "white",
                    fontFamily: "courier-new,courier,monospace!important",
                    fontSize: "14px",
                  }}
                  value={monthlyPerformanceStore.sqlCommand}
                  rows={11}
                  readOnly={true}
                ></TextArea>
              )}
            </Observer>
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm4"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "flex-start",
                  padding: "10px",
                }}
              >
                <Tooltip title="Open a SQL scratch pad to write custom advanced queries">
                  <Button
                    type="danger"
                    onClick={() => {
                      monthlyPerformanceStore.queryGrid = queryGrid;

                      monthlyPerformanceStore.showAdvanceQueryDialog = true;
                    }}
                  >
                    Edit Query Script
                  </Button>
                </Tooltip>
              </div>
              <div
                className="ms-Grid-col ms-sm8"
                style={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "flex-end",
                  padding: "10px",
                }}
              >
                <Space>
                  <Button
                    type="primary"
                    icon={<SaveFilled size={16} style={{ margin: "5px" }} />}
                    onClick={() => {
                      monthlyPerformanceStore.showSaveDialog = true;
                    }}
                  >
                    {" "}
                    Save as Query Template...
                  </Button>
                </Space>
              </div>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm7"
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "flex-end",
              padding: "10px",
            }}
          >
            <Space>
              <Button
                type="link"
                onClick={() => {
                  confirm({
                    title: `proceeed with clearing?`,
                    content: (
                      <span style={{ color: "red" }}>
                        this operation will clear the current query command text
                      </span>
                    ),

                    cancelText: "Cancel",
                    onOk: () => {
                      try {
                        monthlyPerformanceStore.sqlCommand = "";
                        monthlyPerformanceStore.queryColumns = [];
                        if (queryGrid.current) {
                          queryGrid.current.api.setColumnDefs([]);
                          qryBldrObj.current.reset();
                        }
                      } catch (error) {
                        notification.error({
                          key: "error",
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                  });
                }}
              >
                <X size={16} style={{ marginRight: "5px", marginTop: "5px" }} />{" "}
                Clear Sript and Results window
              </Button>
              <Tooltip title="Execute SPARS production query ">
                <Button
                  type='link'
                  disabled={
                    monthlyPerformanceStore.sqlCommand.length === 0 ||
                    monthlyPerformanceStore.saveQueryType !== 1
                  }
                  shape='round'
                  // loading={monthlyPerformanceStore.isQuerying}
                 
                >
                  {" "}
                  <Play
                    size={64}
                    style={{ marginRight: "5px", marginTop: "5px",color:"#52c41a"}}
                    onClick={async () => {
                      try {
                        const retVal = await monthlyPerformanceStore.query();
  
                        if (retVal) {
                          const { displayColumns, data } = retVal;
                          console.log({
                            displayColumns,
                            data,
                          });
                          queryGrid.current.api.setColumnDefs(displayColumns);
                          monthlyPerformanceStore.queryResults = data;
                          
                        } else {
                          monthlyPerformanceStore.showEmpty = true;
                        }
                        monthlyPerformanceStore.queryGrid = queryGrid.current;
                      } catch (error) {
                        console.log(error);
                        monthlyPerformanceStore.showEmpty = true;
                        monthlyPerformanceStore.queryResults.clear();
                        const { response } = error;
                        if (response?.text) {
                          notification.error({
                            message: "SPARS Vulnerability Manager",
                            description: response?.text,
                          });
                        } else {
                          notification.error({
                            message: "SPARS Feeedback Manager",
                            description: error.message,
                          });
                        }
                      }
                    }}
                  />{" "}
                  Execute Script
                </Button>
              </Tooltip>
            </Space>
          </div>
        </div>
        {monthlyPerformanceStore.isQuerying && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {" "}
              <ProgressIndicator
                description="processing, please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}
      </div>
      {monthlyPerformanceStore.isQuerying ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <Observer>
          {() => (
            <div>
               <Divider>SPARS query Result Pane</Divider>
              {!monthlyPerformanceStore.showEmpty ? (
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <CommandBar
                        items={[
                          {
                            key: "dl",
                            onRender: () => (
                              <SubPageHeaderTitle
                                title={monthlyPerformanceStore.gridHeader}
                              />
                            ),
                          },
                        ]}
                        farItems={[
                          {
                            onRenderIcon: () => (
                              <FilePdfOutlined className="qicon" />
                            ),
                            text: "Export as Pdf",
                            onClick: () => {
                              monthlyPerformanceStore.showPdfExportDialog = true;
                            },
                            key: "group5",
                          },
                          {
                            key: "group4",

                            text: (
                              <Tooltip title="Export displayed production data to excel">
                                Export to Excel
                              </Tooltip>
                            ),
                            name: "group",
                            onRenderIcon: () => (
                              <FileExcelOutlined
                                className="qicon"
                                style={{ color: "green" }}
                              />
                            ),

                            onClick: async () => {
                              try {
                                await queryGrid.current.api.exportDataAsExcel({
                                  sheetName: "query export",

                                  allColumns: true,
                                  columnGroups: true,
                                  skipFooters: false,
                                  skipGroups: false,
                                  skipHeader: false,
                                  skipPinnedTop: false,
                                  skipPinnedBottom: false,
                                  fileName: "production_query__result",
                                  skipColumnGroupHeaders: false,
                                  skipColumnHeaders: false,
                                });
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: "export failed",
                                });
                              } finally {
                              }
                            },
                          },
                        ]}
                      />
                    </div>
                  </div>
                 
                  <div className="ms-Grid-row">
                    <div
                      className="ag-theme-balham"
                      style={{
                        minHeight: "50vh",
                        height: "65vh",
                        width: "100%",
                        maxHeight: "80vh",
                      }}
                    >
                      {" "}
                      <AgGridReact
                        rowData={[
                          ...monthlyPerformanceStore.queryResults.values(),
                        ]}
                        sideBar={["columns", "filters"]}
                        ref={queryGrid}
                        gridOptions={{
                          defaultColDef: {
                            sortable: true,
                            filter: true,
                            enableValue: true,
                            enableRowGroup: true,
                            enablePivot: true,
                          },
                          autoGroupColumnDef: {
                            cellRendererParams: {
                              suppressCount: true,
                              checkbox: true,
                            },
                          },
                          enableCharts: true,
                          enableRangeSelection: true,
                          pivotColumnGroupTotals: "after",
                          pivotRowTotals: "after",
                          groupIncludeFooter: true,
                          groupIncludeTotalFooter: true,
                          rowSelection: "single",
                          pagination: true,
                          columnDefs: monthlyPerformanceStore.queryColumns,
                          animateRows: true,
                          statusBar: {
                            statusPanels: [
                              {
                                statusPanel: "agTotalRowCountComponent",
                                align: "center",
                              },
                            ],
                          },
                          columnTypes: {
                            numberColumn: {
                              width: 130,
                              filter: "agNumberColumnFilter",
                            },
                            medalColumn: {
                              width: 100,
                              columnGroupShow: "open",
                              filter: false,
                            },
                            nonEditableColumn: { editable: false },
                            dateColumn: {
                              filter: "agDateColumnFilter",
                              filterParams: {
                                comparator: function (
                                  filterLocalDateAtMidnight,
                                  cellValue
                                ) {
                                  var dateParts = cellValue.split("/");
                                  var day = Number(dateParts[0]);
                                  var month = Number(dateParts[1]) - 1;
                                  var year = Number(dateParts[2]);
                                  var cellDate = new Date(year, month, day);
                                  if (cellDate < filterLocalDateAtMidnight) {
                                    return -1;
                                  } else if (
                                    cellDate > filterLocalDateAtMidnight
                                  ) {
                                    return 1;
                                  } else {
                                    return 0;
                                  }
                                },
                              },
                            },
                          },
                        }}
                        rowSelection="single"
                        copyHeadersToClipboard={true}
                        overlayLoadingTemplate={`${(
                          <span class="ag-overlay-loading-center">
                            Please wait while your rows are loading
                          </span>
                        )}`}
                        overlayNoRowsTemplate={
                          '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
                        }
                        //  onGridReady={onGridReady}
                      ></AgGridReact>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="ms-Grid" dir="ltr">
                  <div
                    className="ms-Grid-row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12">
                      {" "}
                      <Empty />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Observer>
      )}
      <PDFExportPanel />
    </Drawer>
  );
});

